import Button from "../button";
import {
  ArrowLeft,
  Calendar,
  ChevronLeft,
  ChevronRight,
  Logout,
  WorkfullyLogo,
} from "../../assets/icons";
import Tooltip from "../tooltips/Tooltips";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const ICON_COLOR = "#374151";

const navLinkClassName = ({ isActive }) =>
  [
    "w-full flex gap-4 items-center px-2 py-3 cursor-pointer rounded-lg border-0 no-underline transition-colors text-sm font-normal leading-normal",
    isActive
      ? "bg-gray-100 text-gray-700 hover:bg-gray-100"
      : "text-gray-700 hover:bg-gray-50",
  ].join(" ");

const actionLinkClassName =
  "w-full flex gap-4 items-center px-2 py-3 cursor-pointer rounded-lg border-0 text-gray-700 hover:bg-gray-50 transition-colors text-sm font-normal leading-normal";

const SidebarParameters = () => {
  const navigate = useNavigate();
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const logout = () => {
    localStorage.removeItem("companyId");
    localStorage.removeItem("badgerId");
    localStorage.removeItem("companyName");
    localStorage.removeItem("badgerName");
    navigate("/");
  };

  const [sidebarElements] = useState([
    {
      title: "Suivi horaire",
      icon: <Calendar wh={20} color={ICON_COLOR} />,
      path: "/app/parameters",
      type: "content",
    },
    {
      title: "Retour",
      icon: <ArrowLeft wh={20} color={ICON_COLOR} />,
      path: "/app/badger",
      type: "content",
    },
    {
      title: "Déconnexion",
      icon: <Logout wh={20} color={ICON_COLOR} />,
      type: "footer",
      onClick: logout,
    },
  ]);

  return (
    <div
      className={`px-5 py-8 flex flex-col h-full ${sidebarExpanded ? "w-64 transition-w-64" : "w-20 transition-w-20"} duration-700 gap-11 border-r border-r-gray-100 bg-gray-50`}
    >
      <div className={"flex justify-between gap-8 items-center"}>
        {sidebarExpanded && (
          <div>
            <WorkfullyLogo w={130} h={30} />
          </div>
        )}
        <Tooltip
          text={sidebarExpanded ? "Reduire" : "Agrandir"}
          placement="right"
        >
          <div>
            <Button
              color={"ICON"}
              size={"ICON"}
              onClick={() => setSidebarExpanded(!sidebarExpanded)}
            >
              {sidebarExpanded ? (
                <ChevronLeft wh={20} color={"#374151"} />
              ) : (
                <ChevronRight wh={20} color={"#374151"} />
              )}
            </Button>
          </div>
        </Tooltip>
      </div>
      <div className={"flex-1 py-4 text-sm"}>
        {/*only élement with type: "content"*/}
        {sidebarElements
          .filter((element) => element.type === "content")
          .map((element, key) => {
            return (
              <NavLink
                to={element.path}
                key={key}
                className={({ isActive }) => navLinkClassName({ isActive })}
              >
                <div>{element.icon}</div>
                {sidebarExpanded && <div>{element.title}</div>}
              </NavLink>
            );
          })}
      </div>
      <div className={"text-sm"}>
        {sidebarElements
          .filter((element) => element.type === "footer")
          .map((element, key) => {
            if (element.onClick) {
              return (
                <div
                  key={key}
                  className={actionLinkClassName}
                  onClick={element.onClick}
                >
                  <div>{element.icon}</div>
                  {sidebarExpanded && <div>{element.title}</div>}
                </div>
              );
            } else {
              return (
                <NavLink
                  to={element.path}
                  key={key}
                  className={({ isActive }) => navLinkClassName({ isActive })}
                >
                  <div>{element.icon}</div>
                  {sidebarExpanded && <div>{element.title}</div>}
                </NavLink>
              );
            }
          })}
      </div>
    </div>
  );
};

export default SidebarParameters;
